import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { Axle, EvaluationVehicle } from '@app-model/evaluation';
import { Vehicle } from 'src/app/shared/model/vehicle';

@Component({
  selector: 'app-card-axle-and-tire',
  templateUrl: './card-axle-and-tire.component.html',
  styleUrls: ['./card-axle-and-tire.component.scss']
})
export class CardAxleAndTireComponent implements OnInit {
  
  @Input() castOffVehicle?: Vehicle;
  @Input() vehicle?: EvaluationVehicle;


 get data(): Vehicle | EvaluationVehicle | undefined {
    return this.castOffVehicle || this.vehicle;
  }

  get tiresCount(): number {
    return this.axles.reduce((total, axle) => total + (axle.tireCount), 0);
  }

  isTruck = false;
  tiresByAxle = new Map<number, FormArray>();
  axles: Axle[] = [];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const vehicleData = this.data;
    if (!vehicleData) {
      console.warn('CardAxleAndTire: no vehicle data provided');
      return;
    }
    this.isTruck = vehicleData.segment === 'TRUCK';
    this.initAxleAndTires(vehicleData);
  }

  private initAxleAndTires(data: Vehicle | EvaluationVehicle): void {
  // 1) pega os eixos do próprio objeto
  this.axles = data.axleAndTire?.axles || [];

  // 2) pega *qualquer* tireReports que exista em data
  const anyData = data as any;
  const reports: Array<{
    axlePosition: number;
    tirePosition: number;
    color: string;
    classification: string;
  }> = Array.isArray(anyData.tireReports) ? anyData.tireReports : [];

  // 3) popula o Map para cada relatório
  this.tiresByAxle.clear();
  for (const item of reports) {
    const pos = item.axlePosition;
    if (!this.tiresByAxle.has(pos)) {
      this.tiresByAxle.set(pos, this.fb.array([]));
    }
    const group = this.fb.group({
      axlePosition: [item.axlePosition],
      tirePosition: [item.tirePosition],
      color: [item.color],
      classification: [item.classification],
    });
    this.tiresByAxle.get(pos)!.push(group);
  }
}

}
